import { connect } from 'react-redux';

import { getUserContext } from 'selectors/user';
import { signout } from 'actions/AuthActions';

import NavAccount from './NavAccount';

export const mapStateToProps = (state) => ({
  userContext: getUserContext(state),
});

export const mapDispatchToProps = (dispatch) => ({
  onLogOut: (destination) => {
    dispatch(signout()).then(() => {
      window.location.href = destination;
    });
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(NavAccount);
